/**
 * This function add "selected" class to first item (containing css class - select-list-item) inside container
 * @param container
 */

export default container => {
  const firstItem = container && container.querySelector('.select-list-item')
  firstItem && firstItem.classList.add('selected')
}
